import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import ReactDatatable from "@ashvin27/react-datatable";
import { Container, Row, Col, Card, CardBody, Button } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import Select from "react-select";
import { strings } from "../../localization/OfflinePayments";
import { Language, API_URL, LIMIT } from "../../config";
import { Link } from "react-router-dom";

class OfflinePayments extends React.Component {
  state = {
    records: [],
    loading: true,
    total: 0,
    skip: 0,
    limit: LIMIT,
    currentPage: 1,
    prev: true,
    next: false,
    organisations: [],
    plans: [],
    selectedOrganisation: null,
    selectedPlan: null,
  };

  constructor(props) {
    super(props);
    strings.setLanguage(Language);

    this.columns = [
      {
        key: "rutNumber",
        text: strings.rut_number,
      },
      {
        key: "organisationName",
        text: strings.org_name,
      },
      {
        key: "planName",
        text: strings.plan,
      },
      {
        key: "amount",
        text: strings.amount,
        cell: (record) => `${record.amount || 0}`,
      },
      {
        key: "startDate",
        text: strings.start_date,
        cell: (record) =>
          record.startDate
            ? new Date(record.startDate).toLocaleDateString()
            : "-",
      },
      {
        key: "endDate",
        text: strings.end_date,
        cell: (record) =>
          record.endDate ? new Date(record.endDate).toLocaleDateString() : "-",
      },
    ];

    this.config = {
      show_pagination: false,
      show_info: false,
    };
  }

  componentDidMount() {
    this.getData();
    this.getFilterData();
  }

  getFilterData = () => {
    // Fetch organisations for filter
    fetch(`${API_URL}organisations`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.result) {
          const orgs = res.result.map((item) => ({
            value: item._id,
            label: item.data.name,
          }));
          this.setState({ organisations: orgs });
        }
      })
      .catch((err) => {
        console.error("Error fetching organisations:", err);
      });

    // Fetch plans for filter
    fetch(`${API_URL}plans`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.result) {
          const plans = res.result.map((item) => ({
            value: item._id,
            label: item.data.displayName,
          }));
          this.setState({ plans: plans });
        }
      })
      .catch((err) => {
        console.error("Error fetching plans:", err);
      });
  };

  getData = (skip = 0) => {
    this.setState({ loading: true });

    let params = `?limit=${this.state.limit}&skip=${skip}`;
    if (this.state.selectedOrganisation) {
      params += `&organisationId=${this.state.selectedOrganisation.value}`;
    }
    if (this.state.selectedPlan) {
      params += `&planId=${this.state.selectedPlan.value}`;
    }

    fetch(`${API_URL}plans/offline-payments${params}`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.result && res.result.length > 0) {
          let records = res.result.map((item) => ({
            id: item._id,
            rutNumber: item.data.rutNumber || "-",
            organisationName: item.data.organisationName || "-",
            planName: item.data.planName || "-",
            amount: item.data.amount || 0,
            startDate: item.data.plan_start_date || null,
            endDate: item.data.plan_end_date || null,
            // status: item.data.status || "pending",
            organisationId: item.data.organisation_id,
            planId: item.data.planId,
          }));

          this.setState({
            records: records,
            loading: false,
            next: res.result.length < this.state.limit,
          });
        } else {
          this.setState({
            records: [],
            loading: false,
            next: true,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        this.setState({
          loading: false,
          records: [],
        });
      });
  };

  handleOrganisationChange = (selectedOrganisation) => {
    this.setState({ selectedOrganisation, currentPage: 1, skip: 0 }, () =>
      this.getData(0),
    );
  };

  handlePlanChange = (selectedPlan) => {
    this.setState({ selectedPlan, currentPage: 1, skip: 0 }, () =>
      this.getData(0),
    );
  };

  pageIncrement = () => {
    if (!this.state.next) {
      let skip = this.state.currentPage * this.state.limit;
      this.getData(skip);
      this.setState({
        currentPage: this.state.currentPage + 1,
        prev: false,
        skip: skip,
      });
    }
  };

  pageDecrement = () => {
    if (this.state.skip > 0) {
      let skip = this.state.skip - this.state.limit;
      this.getData(skip);
      this.setState({
        currentPage: this.state.currentPage - 1,
        prev: skip === 0,
        next: false,
        skip: skip,
      });
    }
  };

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title={strings.title}
            subtitle={strings.subtitle}
            className="text-sm-left"
          />
        </Row>

        <Row className="mb-4">
          <Col md="6">
            <Card small>
              <CardBody>
                <label>{strings.filter_org}</label>
                <Select
                  value={this.state.selectedOrganisation}
                  onChange={this.handleOrganisationChange}
                  options={this.state.organisations}
                  isClearable
                  placeholder={strings.select_org}
                />
              </CardBody>
            </Card>
          </Col>
          <Col md="6">
            <Card small>
              <CardBody>
                <label>{strings.filter_plan}</label>
                <Select
                  value={this.state.selectedPlan}
                  onChange={this.handlePlanChange}
                  options={this.state.plans}
                  isClearable
                  placeholder={strings.select_plan}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-3 pb-3">
                <Link to="/manage-offline-payments">
                  <Button
                    size="sm"
                    theme="primary"
                    className="mb-2 float-right"
                  >
                    <i className="material-icons">add</i>{" "}
                    {strings.create_payment}
                  </Button>
                </Link>
                <div className="MainDiv">
                  <div className="table-responsive">
                    <ReactDatatable
                      config={this.config}
                      records={this.state.records}
                      columns={this.columns}
                      loading={this.state.loading}
                    />
                    <nav className="d-flex justify-content-center align-items-center">
                      <ul className="pagination">
                        <li className="page-item">
                          <a
                            className="page-link"
                            href="javascript:;"
                            onClick={this.pageDecrement}
                            style={
                              this.state.prev
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                          >
                            {strings.previous}
                          </a>
                        </li>
                        <li className="page-item">
                          <a
                            className="page-link"
                            href="javascript:;"
                            onClick={this.pageIncrement}
                            style={
                              this.state.next
                                ? { cursor: "not-allowed", color: "gray" }
                                : null
                            }
                          >
                            {strings.next}
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default OfflinePayments;
